import React from 'react';

export const CARD = {
    PADDING: {
        NONE: '',
        EXTRA_SMALL: 'padding--xs',
        SMALL: 'padding--s',
        MEDIUM: 'padding--m',
        LARGE: 'padding--l',
        EXTRA_LARGE: 'padding--xl'
    },
    RADIUS: {
        NONE: '',
        TINY: 'tiny-box-radius',
        EXTRA_SMALL: 'extra-small-box-radius',
        SMALL: 'small-box-radius',
        MEDIUM: 'medium-box-radius',
    }
}

/**
 * @param {{
 *   variant?: 'outlined',
 *   padding?: string,
 *   boxRadius?: string,
 *   rounded?: boolean,
 *   className?: string,
 *   children?: React.ReactNode,
 * }} props
 *
 * NOTE: When using variant='outlined', do not set padding, boxRadius, or rounded.
 * These are all controlled by the outlined variant CSS and will be ignored. This is intentional.
 */
const Card = (props) => {
    const {boxRadius = CARD.RADIUS.SMALL, rounded = true, padding = CARD.PADDING.MEDIUM, className, variant, children, ...other} = props;

    const classes = ['ch-card', className, rounded && 'rounded', variant === 'outlined' && 'ch-card--outlined', padding, boxRadius]
        .filter(Boolean).join(' ');

    return (
        <div className={classes} {...other}>
            {children}
        </div>
    );
}

export default Card;
